import {
  graphSlice,
  GRAPH_PREFERENCE_BASE,
  selectGraphPanel,
} from "connected-components/dashboard/store/graph-slice"
import {
  createTemplateChartHook,
  type TemplateChartResult,
} from "connected-components/dashboard/hooks/create-template-chart-hook"
import type { TemplateChartSettings } from "connected-components/dashboard/store/template-chart-settings"

const useGraphTemplateChartBase = createTemplateChartHook({
  preferenceBase: GRAPH_PREFERENCE_BASE,
  selectPanel: selectGraphPanel,
  setTemplateChartSetting: graphSlice.actions.setTemplateChartSetting,
  seedTemplateChart: graphSlice.actions.seedTemplateChart,
})

// Per-template chart category for the graph panel slice (risk, performance, exposure, content-set,
// factor-sensitivity). Every graph template has a non-null category default, so selectedCategory is
// narrowed to a guaranteed string.
export function useGraphTemplateChart(
  templateKey: string,
  defaults: TemplateChartSettings,
): Omit<TemplateChartResult, "selectedCategory"> & { selectedCategory: string } {
  const result = useGraphTemplateChartBase(templateKey, defaults)
  return { ...result, selectedCategory: result.selectedCategory ?? defaults.selectedCategory ?? "total" }
}
